/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import NumericalButton from './NumericalButton';
import {OrderedMap, Map, fromJS} from 'immutable';
import CloseButton from '../buttons/CloseButton';

class MoneyCounter extends React.Component {

    state: State = {
        sumCoins: 0,
        sumPapers: 0,
        coins: OrderedMap(),
        papers: OrderedMap(),
        disabledCoin: false,
        disabledPapers: false
    };

    static propTypes = {
        msg: React.PropTypes.object,
        coins: React.PropTypes.string,
        onSubmit: React.PropTypes.func.isRequired,
        onClose: React.PropTypes.func.isRequired
    };

    componentWillMount() {
        this.loadCoins();
    }

    constructor(props) {
        super(props);

        this.closeKeyboard = this.closeKeyboard.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.setSumCoins = this.setSumCoins.bind(this);
        this.setSumPapers = this.setSumPapers.bind(this);
        this.unDisableCoins = this.unDisableCoins.bind(this);
        this.unDisablePapers = this.unDisablePapers.bind(this);
        this.setCoin = this.setCoin.bind(this);
        this.setPaper = this.setPaper.bind(this);
        this.prepareZeroCoins = this.prepareZeroCoins.bind(this);
        this.prepareZeroPapers = this.prepareZeroPapers.bind(this);
        this.loadCoins = this.loadCoins.bind(this);
        this.serializeCoins = this.serializeCoins.bind(this);
        this.fillCoins = this.fillCoins.bind(this);
        this.sumCoins = this.sumCoins.bind(this);
    }

    loadCoins() {
        const {coins} = this.props;
        const coinsMap = fromJS(JSON.parse(coins));

        let stateSumCoins = 0;
        let stateSumPapers = 0;
        let stateCoins = this.prepareZeroCoins();
        let statePapers = this.prepareZeroPapers();
        let stateDisabledCoin = false;
        let stateDisabledPapers = false;

        if (typeof coinsMap !== 'undefined' && coinsMap !== null) {
            if (coinsMap.has('coins')) {
                stateCoins = this.fillCoins(stateCoins, coinsMap.get('coins'));
                stateSumCoins = this.sumCoins(stateCoins);
            } else if (coinsMap.has('sumCoins')) {
                stateSumCoins = coinsMap.get('sumCoins');
                stateDisabledCoin = true;
            }

            if (coinsMap.has('papers')) {
                statePapers = this.fillCoins(statePapers, coinsMap.get('papers'));
                stateSumPapers = this.sumCoins(statePapers);
            } else if (coinsMap.has('sumPapers')) {
                stateSumPapers = coinsMap.get('sumPapers');
                stateDisabledPapers = true;
            }
        }

        this.setState({
            sumCoins: stateSumCoins,
            sumPapers: stateSumPapers,
            coins: stateCoins,
            papers: statePapers,
            disabledCoin: stateDisabledCoin,
            disabledPapers: stateDisabledPapers
        });
    }

    serializeCoins() {
        const {sumCoins, sumPapers, coins, papers, disabledCoin, disabledPapers} = this.state;
        let map = Map();

        if (disabledCoin) {
            map = map.set('sumCoins', sumCoins);
        } else {
            map = map.set('coins', coins);
        }
        if (disabledPapers) {
            map = map.set('sumPapers', sumPapers);
        } else {
            map = map.set('papers', papers);
        }

        return map.toJSON();
    }

    fillCoins(emptyCoins, fullCoins) {
        let coins = OrderedMap();
        emptyCoins.forEach((v, k) => {
            coins = coins.set(k, fullCoins.has(k) ? Number(fullCoins.get(k)) : '');
        });
        return coins;
    }

    prepareZeroCoins() {
        return OrderedMap([['1', ''], ['2', ''], ['5', ''], ['10', ''], ['20', ''], ['50', '']]);
    }

    prepareZeroPapers() {
        return OrderedMap([['100', ''], ['200', ''], ['500', ''], ['1000', ''], ['2000', ''], ['5000', '']]);
    }

    sumCoins(coins) {
        let sum = 0;
        coins.forEach((times, coin) => {
            if (!isNaN(times)) {
                sum += Number(times) * Number(coin);
            }
        });
        return sum;
    }

    setCoin(coin, value) {
        const {coins} = this.state;
        const newCoins = coins.set(coin, value);
        let sum = this.sumCoins(newCoins);
        this.setState({coins: newCoins, sumCoins: sum});
    }

    setPaper(paper, value) {
        const {papers} = this.state;
        const newPapers = papers.set(paper, value);
        let sum = this.sumCoins(newPapers);
        this.setState({papers: newPapers, sumPapers: sum});
    }

    setSumCoins(sum) {
        this.setState({sumCoins: sum, disabledCoin: true, coins: this.prepareZeroCoins()});
    }

    setSumPapers(sum) {
        this.setState({sumPapers: sum, disabledPapers: true, papers: this.prepareZeroPapers()});
    }

    unDisableCoins() {
        this.setState({sumCoins: 0, disabledCoin: false});
    }

    unDisablePapers() {
        this.setState({sumPapers: 0, disabledPapers: false});
    }

    onSubmit() {
        const {onSubmit} = this.props;
        const {sumCoins, sumPapers} = this.state;

        const coins = typeof sumCoins === 'undefined' ? 0 : Number(sumCoins);
        const papers = typeof sumPapers === 'undefined' ? 0 : Number(sumPapers);

        onSubmit(coins + papers, this.serializeCoins());
    }

    closeKeyboard() {
        const {onClose} = this.props;
        this.setState({value: 0});
        onClose();
    }

    render() {
        const {sumPapers, sumCoins, disabledCoin, disabledPapers, coins, papers} = this.state;
        const {msg} = this.props;

        return (
            <div className="pageMoney">
                <div className="pageMoney-half">
                        {coins.map((coin, i) => {
                            return (
                                <div className={`pageMoney-row`}
                                     key={'coins-' + i}>
                                  <div className="pageMoney-row-key view-coin">
                                    <div className={`boxBtn color-transparent text-black ${'value-'+i}`}>
                                        <div className="boxBtn-inner">
                                            {/*<span>{i}&nbsp;Kč</span>*/}
                                            <img className="pageMoney-coin" src={`img/czk/${i}_CZK.png`} alt=""/>
                                        </div>
                                    </div>
                                  </div>
                                  <div className="pageMoney-row-key">
                                    <NumericalButton
                                        className={`boxBtn color-white ${disabledCoin ? 'disabled' : ''}`}
                                        nonDecimal
                                        label={`${i} Kč`}
                                        removedClassName="boxBtn"
                                        stringAfter="ks"
                                        onSubmit={(value) => this.setCoin(i, value)}
                                        value={coin}/>
                                  </div>
                                </div>
                            );
                        })}
                        {disabledCoin &&
                        <div className="pageMoney-overflow">
                          <div className="pageMoney-overflow-key">
                            <div className="boxBtn color-white"
                                  onClick={this.unDisableCoins}>
                                <div className="boxBtn-inner">
                                    <span>{msg.moneyCount.fillPcs}</span>
                                </div>
                            </div>
                          </div>
                        </div>
                        }
                    <div className={`pageMoney-row`}>
                      <div className="pageMoney-row-key">
                        <div className="boxBtn text-black text-b">
                            <div className="boxBtn-inner">
                                <span>{msg.moneyCount.sum}</span>
                            </div>
                        </div>
                      </div>
                      <div className="pageMoney-row-key">
                        <NumericalButton className="boxBtn color-white"
                                         removedClassName="boxBtn"
                                         nonDecimal
                                         label="Mince celkem"
                                         stringAfter="Kč"
                                         onSubmit={this.setSumCoins}
                                         value={sumCoins}/>
                      </div>
                    </div>
                </div>

                <div className="pageMoney-half">
                        {papers.map((bill, i) => {
                            return (
                                <div className="pageMoney-row" key={'bills-' + i}>
                                  <div className="pageMoney-row-key view-coin">
                                    <div className={`boxBtn color-transparent text-black ${'value-'+i}`}>
                                        <div className="boxBtn-inner">
                                            {/*<span>{i}&nbsp;Kč</span>*/}
                                            <img className="pageMoney-banknote" src={`img/czk/${i}_CZK.png`} alt=""/>
                                        </div>
                                    </div>
                                  </div>
                                  <div className="pageMoney-row-key">
                                    <NumericalButton
                                        label={`${i} Kč`}
                                        className={`boxBtn color-white ${disabledPapers ? 'disabled' : ''}`}
                                        nonDecimal
                                        removedClassName="box-button"
                                        stringAfter="ks"
                                        onSubmit={(value) => this.setPaper(i, value)}
                                        value={bill}/>
                                  </div>
                                </div>
                            );
                        })}

                        {disabledPapers &&
                        <div className="pageMoney-overflow">
                          <div className="pageMoney-overflow-key">
                        <div className="boxBtn color-white"
                             onClick={this.unDisablePapers}>
                            <div className="boxBtn-inner">
                                <span>{msg.moneyCount.fillPcs}</span>
                            </div>
                        </div>
                          </div>
                </div>
                        }
                    <div className={`pageMoney-row`}>
                      <div className="pageMoney-row-key">
                        <div className="boxBtn text-black text-b">
                            <div className="boxBtn-inner">
                                <span>{msg.moneyCount.sum}</span>
                            </div>
                        </div>
                      </div>
                      <div className="pageMoney-row-key">
                        <NumericalButton className="boxBtn color-white"
                                         removedClassName="boxBtn"
                                         nonDecimal
                                         label="Bankovky celkem"
                                         stringAfter="Kč"
                                         onSubmit={this.setSumPapers}
                                         value={sumPapers}/>
                      </div>
                    </div>
                </div>
                <div className="pageMoney-controls">
                    <div className="pageMoney-controls-key">
                    </div>
                    <div className="pageMoney-controls-key">
                    </div>
                    <div className="pageMoney-controls-key">
                      <div className="boxBtn color-red" onClick={() => this.closeKeyboard()}>
                          <CloseButton className="view-white"/>
                      </div>
                    </div>
                  <div className="pageMoney-controls-key">
                    <div className={`boxBtn text-l color-greenLight`}
                         onClick={() => this.onSubmit()}>
                        <div className="boxBtn-inner">
                            <span>{msg.global.save}</span>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale]
}))(MoneyCounter);



// WEBPACK FOOTER //
// ./src/browser/components/keyboard/MoneyCounter.js